import { modalRenderer } from '~/modal/modalRendererRegistry';
import type { ModalProps } from '~/modal/modalType.enum';
import { MapMigrationCompleteStepModalContainer } from './mapMigrationCompleteStep.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MigrationCompleteStep: {
      closeParent: ModalProps['onClose'];
    };
  }
}

modalRenderer.register('MigrationCompleteStep', (props) => <MapMigrationCompleteStepModalContainer {...props} />);
